export default __webpack_public_path__ + "static/media/negative-film.ea02ca02.png";